import { useState } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import Topbar from "./Topbar";
import MobileNav from "./MobileNav";
import MobileDrawer from "./MobileDrawer";
import AnimatedBackground from "./AnimatedBackground";
import PremierCopilot from "../copilot/PremierCopilot";

export default function AppShell() {
  const [collapsed, setCollapsed] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [copilotOpen, setCopilotOpen] = useState(false);

  return (
    <div
      className="relative min-h-screen flex"
      style={{ background: "var(--pl-bg)", color: "var(--pl-text)" }}
      data-testid="app-shell"
    >
      <AnimatedBackground />
      <Sidebar collapsed={collapsed} onToggle={() => setCollapsed((c) => !c)} />
      <MobileDrawer open={drawerOpen} onOpenChange={setDrawerOpen} />

      <div className="flex-1 min-w-0 flex flex-col">
        <Topbar onMenu={() => setDrawerOpen(true)} />
        <main className="flex-1 px-4 lg:px-8 py-6 lg:py-8 pb-32 lg:pb-12">
          <Outlet />
        </main>
      </div>

      <MobileNav onCopilot={() => setCopilotOpen(true)} />
      <PremierCopilot
        openExternal={copilotOpen ? true : undefined}
        onCloseExternal={() => setCopilotOpen(false)}
      />
    </div>
  );
}
